import client from '../httpClient';

// common: /zips 郵便番号検索
const zipApi = (params) => {
  const GET_ZIPS_URL = '/common/zips';
  return client.get(GET_ZIPS_URL, { params });
};

export default zipApi;
